import addEventListenerToBuyButton from '../../../../home24-shared/components/quickview/functions/eventListeners/buy';
import addEventListenerPictures from './eventListeners/pictures';
import addEventListenerToOptions from './eventListeners/options';
import * as selectors from '../../../../home24-shared/components/quickview/constants/selectors';
import Swiper from 'swiper';

const addSwiper = slidesPerView => {
  new Swiper(`.${selectors.SLIDER}`, {
    direction: 'vertical',
    spaceBetween: 12,
    slidesPerView,
    pagination: {
      clickable: true
    },
    grabCursor: true,
    navigation: {
      nextEl: `.${selectors.SWIPERDOWM}`,
      prevEl: `.${selectors.SWIPERUP}`
    }
  });
};

export function addAllListener(data) {
  const selectableAttributesAmount = Object.keys(data.selectedMvcAttributes)
    .length;
  let slidesPerView = 3;

  if (selectableAttributesAmount === 2 || selectableAttributesAmount === 3) {
    slidesPerView = 4;
  }

  addSwiper(slidesPerView);

  addEventListenerToBuyButton({
    selector: selectors.BUYBUTTON,
    cfg: data.cfg,
    smp: data.smp,
    price: data.price.sellPrice,
    name: data.name,
    variant: data.variantName,
    currencyCode: data.price.currency,
    lng: data.lngcode
  });
  addEventListenerPictures(data.images.length);
  addEventListenerToOptions(
    data.cfg,
    data.otherSkus,
    data.selectedMvcAttributes
  );
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/functions/addAllListeners.js
 **/